import { riskCohortApi } from "api/immunization";
import MasterListScreen from "./common/MasterListScreen";
import RiskCohortModal from "./RiskCohortModal";

const RiskCohortList = ({ searchText = "" }) => (
  <MasterListScreen
    resource={riskCohortApi}
    label="Risk cohort"
    entityLabel="risk cohort"
    addLabel="Add Risk Cohort"
    tag="immunization-risk-cohort"
    headers={[
      "Name",
      "Code",
      "Rules",
      "Logic",
      "Precedence",
      "Status",
      "Action",
    ]}
    keys={[
      "name",
      "code",
      "ruleCount",
      "membershipLogic",
      "precedence",
      "statusChip",
      "action",
    ]}
    displayName={(item) => item.cohortName}
    mapRow={(item) => ({
      ruleCount: (item.membershipRules || []).length || "—",
    })}
    Modal={RiskCohortModal}
    searchText={searchText}
  />
);

export default RiskCohortList;
